var map = {
	"./01": 48,
	"./01.png": 48,
	"./attention-square": 49,
	"./attention-square-invalid": 50,
	"./attention-square-invalid.svg": 50,
	"./attention-square.svg": 49,
	"./bg-flow-dots": 51,
	"./bg-flow-dots.png": 51,
	"./flow-dot-current": 52,
	"./flow-dot-current.svg": 52,
	"./flow-dot-default": 53,
	"./flow-dot-default.svg": 53,
	"./flow-mark-square-blue": 54,
	"./flow-mark-square-blue.svg": 54,
	"./flow-mark-square-white": 55,
	"./flow-mark-square-white.svg": 55,
	"./icon-arrow-left-yellow": 56,
	"./icon-arrow-left-yellow.svg": 56,
	"./icon-arrow-right-yellow": 57,
	"./icon-arrow-right-yellow.svg": 57,
	"./icon-calendar": 58,
	"./icon-calendar.svg": 58,
	"./icon-iup-blue": 59,
	"./icon-iup-blue.svg": 59,
	"./icon-ku": 60,
	"./icon-ku-blue": 61,
	"./icon-ku-blue.png": 61,
	"./icon-ku.png": 60,
	"./icon-student": 62,
	"./icon-student.svg": 62,
	"./img-dummy": 63,
	"./img-dummy.jpg": 63,
	"./logo-iup": 64,
	"./logo-iup.svg": 64,
	"./logo-ku": 65,
	"./logo-ku.svg": 65,
	"./logo-sp": 66,
	"./logo-sp.jpg": 66,
	"./polygon-blue": 67,
	"./polygon-blue.svg": 67,
	"./polygon-white": 68,
	"./polygon-white.svg": 68
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73;